<template>
<div>
  <section id="hero_info">
    <article>
      <div class="main-wraper">
        <img src="/static/renew_img/hero_info.png">
      </div>
      <p class="caption">ヤギッシュの使い方</p>
    </article>
  </section>
	<section class="info-cream">
    <div class="content-wrapper">
      <article class="info">
        <h2 id="info00"><span>目次</span></h2>		
        <ul class="disc">
          <li><a href="#info01">ヤギッシュでできること</a></li>
          <li><a href="#info02">基本的な使いかた</a></li>
          <li><a href="#info03">スマートフォンにPDFをダウンロード保存する方法</a></li>
          <li><a href="#info04">入力した情報の保存</a></li>
          <li><a href="#info05">入力途中で履歴書の種類を変更する方法</a></li>
          <li><a href="#info06">ログインについて</a></li>
          <li><a href="#info07">サーバーへの自動保存</a></li>
          <li><a href="#info08">データのバックアップ作成と復元（引き継ぎ） </a></li>
          <li><a href="#info09">PDFをメールで送信 </a></li>
          <li><a href="#info10">コンビニ印刷サービスを利用する</a></li>
          <li><a href="#info11">推奨環境</a></li>
        </ul>
      </article>
    </div>
	</section>
	<section class="info-cream">
		<div class="content-wrapper">
			<h2 id="info01"><span>ヤギッシュでできること</span></h2>			
				<h3 class="info-title">ヤギッシュは<br class="sp">これらのサービスが利用できます</h3>
				<img src="/static/renew_img/img_info00.png" alt="入力内容をブラウザに自動保存・バックアップと復元・PDFで出力＆メールで送信・コンビニ印刷・転職相談">
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info02"><span>基本的な使いかた</span></h2>
			<img src="/static/renew_img/img_info01.png" alt="">
			<div class="mt40"></div>
			<h3 class="info-title">もっと詳しい使い方</h3>
			<ul class="step">
				<li>
					<p class="step-num"><span>STEP1</span>履歴書を選択する</p>
					<img src="/static/renew_img/img_info-step01.png">
					<p class="plaintext">「この履歴書を選ぶ」を押すと、下図が表示されます。<br><span class="bold">「入力をはじめる」ボタンをタップ</span>します。</p>
				</li>
				<li>
					<p class="step-num"><span>STEP2</span>基本情報の入力</p>
					<img src="/static/renew_img/img_info-step02.png">
					<p class="plaintext">「名前（ふりがな）、生年月日、年齢、性別を入力します。<br>次項も住所、連絡先と入力します。</p>
				</li>
				<li>
					<p class="step-num"><span>STEP3</span>証明写真のアップロード</p>
					<img src="/static/renew_img/img_info-step03.png">
					<p class="plaintext"><span class="bold">「写真をアップロードする」をタップ</span>すると、カメラで撮影するか、写真フォルダからデータを選択するかが表示されます。</p>
				</li>
				<li>
					<p class="step-num"><span>STEP4</span>学歴の入力</p>
					<img src="/static/renew_img/img_info-step04.png">
					<p class="plaintext"><span class="bold">「自動入力」ボタンをタップ</span>すると、最終学歴選択、中学〇年、高校〇年、浪人等〇年、大学〇年、など選択することができます。<br>
					年齢から自動で計算してくれるので、西暦・和暦を調べる必要もありません</p>
				</li>
				<li>
					<p class="step-num"><span>STEP5</span>以下情報の入力を完了する</p>
					<img src="/static/renew_img/img_info-step05.png">
					<p class="plaintext">引き続き情報の入力をすすめましょう。<br>
						<span class="bold">「自動入力」や「例文から追加」の緑色のボタンをタップ</span>すると、テンプレート等が表示される便利な機能なので活用してください。</p>
				</li>
				<li>
					<p class="step-num"><span>STEP６</span>ダウンロード</p>
					<img src="/static/renew_img/img_info-step06.png">
					<p class="plaintext">お疲れ様でした！ログインすると完成したデータを保存できます。<br>
						<span class="bold">「ダウンロードする」ボタンをタップ</span>すると、PDF化された履歴書が表示されます。</p>
				</li>
			</ul>	
			<div class="mt40"></div>
			<h3 class="info-title">動画でヤギッシュの使い方を紹介</h3>
			<iframe width="560" height="315" src="https://www.youtube.com/embed/OeJnU_F8RX8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			<ul class="disc">
				<li>Yagishってなに？　2:12~</li>
				<li>履歴書を作ってみよう！　5:05~
					<p class="plaintext">
						└ プロフィールを入力　6:21~<br>
						└ 住所を入力　7:48~<br>
						└ 連絡先を入力　8:46~<br>
						└ 証明写真をアップロード　9:32~<br>
						└ 免許・資格を入力　13:08~<br>
						└ 自己PRを入力　14:10~<br>
						└ 通勤時間ほか　14:27~<br>
						└ 本人希望欄を入力　14:45~<br>
						└ 履歴書の作成日を入力　15:41~<br>
					</p>
				</li>
				<li>コンビニで印刷してみよう！　17:05~</li>
				<li>印刷してきました！(印刷時の注意事項)　19:40~
					<p class="plaintext">
						└ ローソン・ファミリーマートでの印刷を推奨しております。
					</p>
				</li>

				<li>Yagishを使ってみた感想　21:10~</li>				
			</ul>
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info03"><span>スマートフォンに<br class="sp">PDFをダウンロード保存する</span></h2>			
			<h3 class="info-title">iphoneから<br class="sp">ダウンロード・保存する場合</h3>
			<ul class="step">
				<li>
					<p class="step-num"><span>STEP1</span>シェアボタンをタップ</p>
					<img src="/static/renew_img/img_info-step07.png">
					<p class="plaintext"><span class="bold">「ダウンロード」ボタンをタップ</span>し、履歴書のページが表示されたことを確認してください。<br>
						Safariのメニューバーが表示されたら、<span class="bold">シェアボタンアイコンをタップ</span>します。</p>
				</li>
				<li>
					<p class="step-num"><span>STEP2</span>ファイルに保存をタップ</p>
					<img src="/static/renew_img/img_info-step08.png">
					<p class="plaintext">メニューが表示されるので、<span class="bold">「ファイルに保存」をタップします</span></p>
				</li>
				<li>
					<p class="step-num"><span>STEP3</span>ファイル名をつけ保存する</p>
					<img src="/static/renew_img/img_info-step09.png">
					<p class="plaintext">①の部分をタップすると、ファイル名が編集できます。<br>
						②保存先を<span class="bold">「このiphone内」</span>にします。<br>
						③<span class="bold">右上の「保存」をタップ</span>して保存完了です。<br>
						<span class="gray">※icloudに保存したい方は「icloud drive」を選択ください。ほか、ダウンロード済のアプリ（dropbox、pagesなど）に保存したい場合はそのアプリを選択します。</span>
					</p>
				</li>
			</ul>

		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info04"><span>入力した情報の保存</span></h2>		
			<p class="plaintext">
				入力した情報はご利用の端末のブラウザ（SafariやChromeなど）の履歴に保存され、ブラウザを閉じても再度サイトにアクセスした際に続きを入力できるようになっています。<br><br>
				<span class="red">
				共用パソコン(ネットカフェや学校など複数の人が利用するパソコン)などでご利用いただく場合、パソコン内に残ったデータを他の人に見られてしまう可能性があります。yagishでは、サービスをご利用いただいた後にデータを削除することを推奨しております。
				</span>				
			</p>
			<div class="mt40"></div>
			<div class="delite">
				<a href="https://rirekisho.yagish.jp/account/delete" class="btn_green">データ・アカウントの削除</a>
			</div>
			<p class="plaintext">
				また、「設定 ＞ データ・アカウントの削除画面を開く ＞ ブラウザのデータを削除する」からでもブラウザの履歴を削除できます。<br>
				<span class="gray">
					・ブラウザの入力履歴はサーバーに保存されないため、その端末を使用している人しか見ることはできません。<br>
					・会員登録（Googleアカウントでログイン）を行うと、ブラウザの履歴とは別にサーバーへ情報の保存ができるようになります。他の端末に情報を引き継いだり、データを繰り返し使うときにおすすめです。
				</span>
			</p>
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info05"><span>入力途中で<br class="sp">履歴書の種類を変更する</span></h2>		
			<img src="/static/renew_img/img_info02.png">
			<p class="plaintext">
				入力途中で履歴書の種類を変えた場合、同じ項目であればそのまま内容が引き継がれます。<br>
				代わりに、履歴書ごとに別々の内容を保存することができないようになっています。<br>
				もしデータを保存しておきたい場合は、「マイページ > バックアップを作成」で現時点の内容を手動で保存しておくと、必要なときにその内容を復元することができます。
			</p>
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info06"><span>ログイン</span></h2>		
			<img src="/static/renew_img/img_info03.png">
			<p class="plaintext">
				ログインは右上の「ログイン」ボタンからできます。
			</p>
			<img src="/static/renew_img/img_info04.png">
			<p class="plaintext">
				Googleアカウントをお持ちでない場合は、事前にGoogleアカウントの作成が必要です。<br><br>
				<a href="https://accounts.google.com/SignUp?hl=ja" target="_blank">Googleアカウントの作成</a><br>
				<a href="https://support.google.com/accounts/answer/27441?hl=ja" target="_blank">Google アカウント ヘルプ</a>
			</p>
			
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info07"><span>サーバーへの自動保存<br class="sp"><span class="min">※ログイン時のみ</span></span></h2>		
			<img src="/static/renew_img/img_info02.png">
			<p class="plaintext">
				ログイン（Googleアカウントでログイン）すると、入力内容の自動保存が行われます。<br>
				また、「設定」から手動で現時点のバックアップを作成することも可能です。<br>
				<span class="gray">※ Googleアカウントでログインしている必要があります。</span>
			</p>
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info08"><span>データのバックアップ作成と<br class="sp">復元（引き継ぎ） <br class="sp"><span class="min">※ログイン時のみ</span></span></h2>		
			<p class="plaintext">
				<span class="red">
				必ず「バックアップを作成」する必要があります。<br>
				バックアップを作成しないと次回ログイン時にバックアップを復元することができません。</span>
			</p>
			<img src="/static/renew_img/img_info02.png">
			<p class="plaintext">	
				「バックアップの作成」はログイン後、マイページで<span class="bold">「バックアップを作成する」をタップ</span>することで作成されます。
			</p>
			<img src="/static/renew_img/img_info05.png">
			<p class="plaintext">	
				マイページから引き継ぎたいバックアップの<span class="bold">「この履歴書を選択」をタップ</span>します。
			</p>
			<img src="/static/renew_img/img_info06.png">
			<p class="plaintext">	
				ページ下の<span class="bold">「復元する」ボタンをタップ</span>すると読み込まれます。
			</p>
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info09"><span>PDFをメールで送信<br class="sp"><span class="min">※ログイン時のみ</span></span></h2>		
			<img src="/static/renew_img/img_info07.png">
			<p class="plaintext">	
				作成したPDFを、自分のGmail宛に送信することができます。<br>
				履歴書の入力画面を最後まで進むと<span class="bold">「PDFをメールで送る」ボタン</span>がありますので、こちらをタップしてください。<br>
				<span class="gray">※ Googleアカウントでログインしている必要があります。</span>
			</p>
		</div>
	</section>
	<section class="info-white">
		<div class="content-wrapper">
			<h2 id="info10"><span>コンビニ印刷サービスを<br class="sp">利用する<br class="sp"><span class="min">※ログイン時のみ</span></span></h2>		
			<p class="plaintext">	
				近くのコンビニで簡単に印刷することができます。<br>
				<span class="gray">
					※全てのテンプレートに対応しております。<br>
					※履歴書内の写真をカラーで印刷する対応もしております。<br>
					※職務経歴書のコンビニ印刷は、最大8ページ(白黒A4両面4枚)までの対応となります。
				</span>
			</p>
			<img src="/static/renew_img/img_info08.png">
			<p class="plaintext">
				ダウンロード画面にある<span class="bold">「コンビニで印刷する」ボタンをタップ</span>すると、印刷される内容を確認ができるプレビュー画面が表示されます。
			</p>
			<img src="/static/renew_img/img_info09.png">
			<p class="plaintext">
				プレビュー画面下部にある<span class="bold">「コンビニで印刷する」ボタンをタップ</span>します。
			</p>
			<img src="/static/renew_img/img_info10.png">
			<p class="plaintext">
				印刷するタイプを選択し「利用規約に同意して印刷する」ボタンをタップします。
			</p>
			<img src="/static/renew_img/img_info11.png">
			<p class="plaintext">
				期限日時以内にコンテンツ番号を控えて上、印刷を行ってください。<br>
				印刷部数の指定、お支払いなどはコンビニで行います。<br>
				<span  class="gray">※コンテンツ番号発行後、24時間が有効期限となります。<br>
				※セブンイレブンやマルチコピー機でも印刷はできますが、印刷方法がローソン、ファミリーマートと異なりますのでご注意ください。</span><br>
				<a href="https://www.e-printservice.net/shohin/yagish" target="_blank">詳しい利用方法を確認する</a>

			</p>
		</div>
	</section>
	<section class="info-cream">
		<div class="content-wrapper">
			<h2 id="info11"><span>推奨環境</span></h2>		
			<p class="plaintext">
				パソコン、スマートフォンどちらでも利用可能です。
				オフライン機能など、すべての機能を快適にご使用いただく場合は、下記の環境を推奨いたします。
			</p>
			<ul class="disc">
				<li>
					Androidスマートフォン
					<p class="plaintext">OS: 8.0.0以降、<span class="bold">ブラウザ: GoogleChrome</span></p>
				</li>
				<li>
					iPhone
					<p class="plaintext">OS: 11.3以降、<span class="bold">ブラウザ: Safari</span></p>
				</li>
				<li>
					Windows
					<p class="plaintext">OS: Windows10、ブラウザ: GoogleChrome</p>
				</li>
				<li>
					Mac
					<p class="plaintext">OS: High Sierra、ブラウザ: GoogleChrome</p>
				</li>
			</ul>
			<p class="plaintext">
				<span class="gray">※ サポートが終了しているOS・ブラウザ（例:WindowsXP、Internet Explorer10以下など）ではサービスが正常に動作しない可能性があります。</span>
			</p>
		</div>
	</section>
</div>
</template>
<style lang="css" src="@/assets/css/renew_info.css"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
